import { render } from "./top-table.vue?vue&type=template&id=531686b2&scoped=true"
import script from "./top-table.vue?vue&type=script&lang=js"
export * from "./top-table.vue?vue&type=script&lang=js"

import "./top-table.vue?vue&type=style&index=0&id=531686b2&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531686b2"]])

export default __exports__